import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { NvMatTooltipModule } from '../../../../shared/components/nv-mat-tooltip/nv-mat-tooltip.module';
import { NvTooltipModule } from '../../../../shared/nv-tooltip/nv-tooltip.module';
import { ListDisplayModule } from './../list-display.module';
import { ListDisplayMilestone } from './list-display-milestone.component';

@NgModule({
  declarations: [ListDisplayMilestone],
  imports: [CommonModule, ListDisplayModule, NvMatTooltipModule, NvTooltipModule],
  exports: [ListDisplayMilestone],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class ListDisplayMilestoneModule {
  /** */
}
